var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "#C72133",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.993 12.005c-.91 0-1.751-.303-2.425-.813A4.048 4.048 0 0 1 18.963 8h-2.602v7.138l-.003 3.908c0 1.046-.68 1.931-1.617 2.244a2.357 2.357 0 0 1-1.95-.216A2.363 2.363 0 0 1 14.74 16.8v-2.647a4.964 4.964 0 0 0-.751-.056c-1.44 0-2.787.6-3.75 1.683a4.923 4.923 0 0 0 .222 6.769A4.973 4.973 0 0 0 13.99 24a4.972 4.972 0 0 0 3.528-1.452 4.899 4.899 0 0 0 1.461-3.48l-.012-5.838c.445.347.935.632 1.461.854.817.348 1.683.52 2.571.52v-2.602c.003.003-.006.003-.006.003Z",
    fill: "#FFF",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.d93e1b080f10dc3122eee1216306b4b3.svg";
export { ForwardRef as ReactComponent };